import React, { FC } from 'react';
import { Text } from '@blueprint/text';
import { Link } from '@blueprint/link';
import {
    Content,
    StyledButton,
    StyledText,
    StyledLinkContainer,
    StyledImg,
    StyledHeading,
    StyledIcon
} from './ResponseModalContent.styles';

export type Props = {
    image: string;
    title: string;
    heading: string;
    text: string;
    buttonAction: () => void;
    buttonText: string;
    linkType: 'url' | 'action';
    linkUrl?: string;
    linkAction?: () => void;
    linkText: string;
    note: string;
};

export const ResponseModalContent: FC<Props> = ({
    image,
    title,
    heading,
    text,
    buttonAction,
    buttonText,
    linkType,
    linkUrl,
    linkText,
    linkAction,
    note
}) => (
    <Content>
        <StyledImg src={image} alt={title} />
        <StyledHeading size="5">{heading}</StyledHeading>
        <StyledText size="secondary">{text}</StyledText>
        <StyledButton onClick={buttonAction} color="primary-brand">
            {buttonText}
        </StyledButton>
        <StyledLinkContainer>
            {linkType === 'url' ? (
                <Link href={linkUrl as string}>{linkText}</Link>
            ) : (
                <Link onClick={linkAction} href="">
                    {linkText}
                </Link>
            )}
        </StyledLinkContainer>
        <Text size="small">
            <StyledIcon iconId="padlock" />
            {note}
        </Text>
    </Content>
);
